import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "Yes, however, once zippers or lock are tampered with (e.g. break-in/burglary/robbery), the damage leaves visible tampering evidence/proofs allowing luggage owner to seek insurance claims/damages from transport/airport operator. In contrast, stealing or theft achieved by cracking a combination/key lock provides no physical tampering evidence of stolen contents, hence luggage owner is unable to raise a case to seek compensation.",
    reply2:
      "Alternatively, for satisfying your higher security needs, you may get Zipperless types of heavy-duty (metal casing) luggage built with eGeeTouch® smartlock instead.",
    back: "Back",
  },
  ja: {
    reply1:
      "はい、ただし、ジッパーやロックが改ざんされると（例：不法侵入、強盗、強盗）、その損傷により目に見える改ざんの証拠が残り、荷物の所有者は運送会社/空港運営者に保険請求/損害賠償を求めることができます。対照的に、コンビネーション/キーロックを破ることによって達成された窃盗または窃盗は、盗まれた内容物の物理的な改ざんの証拠を提供しないため、荷物の所有者は賠償を求める訴訟を起こすことができません。",
    reply2:
      "あるいは、より高度なセキュリティのニーズを満たすために、代わりに eGeeTouch® スマートロックを搭載したジッパーレス タイプの頑丈な (金属ケース) スーツケースを入手することもできます。",
    back: "戻る",
  },
  es: {
    reply1:
      "Sí, sin embargo, una vez que se manipulan las cremalleras o las candados (por ejemplo, robo/robo), el daño deja evidencia/pruebas de manipulación visibles que permiten al propietario del equipaje reclamar reclamaciones de seguro/daños al operador de transporte/aeropuerto. Por el contrario, el robo o hurto logrado abriendo una candado de combinación/llave no proporciona evidencia de manipulación física del contenido robado, por lo que el propietario del equipaje no puede presentar un caso para solicitar una compensación.",
    reply2:
      "Alternativamente, para satisfacer sus mayores necesidades de seguridad, puede adquirir tipos de equipaje resistente (con carcasa metálica) sin cremallera construidos con candado inteligente eGeeTouch®.",
    back: "Atrás",
  },
});

class Q13_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q13_component;
